export let localeConfig = {
	enabledLanguages: [],
};

export const setter = (props) => {
	localeConfig = {
		...localeConfig,
		...props,
	};
};
